const filesTypography = {
  label: 'Arquivos de apoio GEEQUIP'
};

export default filesTypography;
